import { ApplicationDto } from "./application-dto";
import { MakeToOrderDto } from "./make-to-order-dto";
import { Order } from "./order";
import { ResponseManagement } from "./response-management";
import { ReturnMto } from "./return-mto";
import { ReturnOrder } from "./return-order";
import { Tracks } from "./tracks";
import { Weborder } from "./weborder";

export class MonitoringDashboardDto {

    responseManagement: ResponseManagement = new ResponseManagement();
    tracks: Tracks = new Tracks();
    webOrders: Weborder = new Weborder();
    application: ApplicationDto = new ApplicationDto();
}
